<template>
  <div class="contentBox">
    <!-- 表格数据 -->
    <div class="tableBox">
      <!-- 我的创新券 -->
      <JRtable :table-data="currentUsersData" :selection="false" :show-pagination="true" :column="currentUsersColumns"
        @page-change="handlePageChange" :pageOptions="pageOptions" size="mini" :border="true" :index="true">
        <div class="innovationVoucher">
          <img src="@/assets/images/table-tab.png" width="8px" height="23px" />
          <span>企业兑付列表</span>
        </div>
        <!-- <template slot="slot_record_tools" slot-scope="data">
          <el-button @click="handleViewRedemptionDetails(data.scope.row, '查看')" size="mini" type="primary" icon="el-icon-view">查看</el-button>
        </template>         -->
      </JRtable>
    </div>
    <!-- 企业新增兑付信息弹窗表单 -->
    <Dialog :visible.sync="showDialog" width="1600px" title="企业兑付申请表" :showBtn="false" @close="showDialog = false"
      :append-to-body="true">
      <template #content>
        <div class="applyform">
          <!-- 表单组件 -->
          <component :is="test" v-if="showDialog" @closeDialog="closeDialog" :operation="true" :operation2="false"
            :operation1="true" :uuid="uuid" ref="childRef" :receiptStatus="false"></component>
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import WelcomeBox from '@/components/WelcomeBox'
import JRtable from '@/components/Table'
import Dialog from '@/views/enterprise/components/Dialog'
import exchangeApplyForm from '@/views/applyForm/exchangeApplyForm'
import { getPageExchangeList } from '@/api/enterprise/exchangelist'
export default {
  components: {
    WelcomeBox,
    JRtable,
    Dialog,
    exchangeApplyForm
  },
  data() {
    return {
      test: 'exchangeApplyForm',
      uuid: '',
      // 企业兑付情况
      currentUsersData: [],
      currentUsersColumns: [
        {
          label: '项目名称',
          prop: 'supportedProjectName',
          align: 'center',
          // width: 200,
          truncate: true
        },
        {
          label: '企业名称',
          prop: 'fwgmf',
          align: 'center',
          // width: 200,
          truncate: true
        },
        {
          label: '二级机构名称',
          prop: 'fwjgmc',
          align: 'center',
          // width: 200,
          truncate: true
        },
        {
          label: '兑付金额(元)',
          prop: 'hzdfje',
          align: 'center',
          // width: 200,
          truncate: true
        },
        // {
        //   label: '服务机构',
        //   prop: 'fwjgmc',
        //   align: 'center',
        //   width: 200,
        //   truncate: true
        // },
        // {
        //   label: '服务名称',
        //   prop: 'fwmc',
        //   align: 'center',
        //   width: 200,
        //   truncate: true
        // },
        // {
        //   label: '服务类型',
        //   prop: 'fwflmc',
        //   align: 'center',
        //   width: 200,
        //   truncate: true
        // },
        // {
        //   label: '合同金额(元)',
        //   prop: 'htje',
        //   align: 'center',
        //   width: 150
        // },

        // {
        //   label: '本次兑付金额(元)',
        //   prop: 'bckdfje',
        //   align: 'center',
        //   width: 150
        // },
        // {
        //   label: '区划',
        //   prop: 'qyszqName',
        //   align: 'center',
        //   width: 150
        // },
        // {
        //   label: '办件状态',
        //   prop: 'spztName',
        //   align: 'center',
        //   width: 200
        // },
        // {
        //   label: '操作',
        //   prop: '',
        //   align: 'center',
        //   width: 200,
        //   fixed: 'right',
        //   slot: 'slot_record_tools'
        // }
      ],
      pageOptions: {
        limit: 10,
        page: 1,
        total: 0,
        lqqytysfrz: ''
      },
      showDialog: false,
      exchangeForm: {} //详情数据
    }
  },
  mounted() {
    this.getCouponList()
  },
  methods: {
    // 获取企业兑付情况列表信息
    async getCouponList() {
      let formData = {
        page: this.pageOptions.page,
        limit: this.pageOptions.limit,
        groupType: 2,
        dfztMapping: 13,
      }
      const result = await getPageExchangeList(formData)
      if (result.code === 200) {
        this.currentUsersData = result.data.records
        this.pageOptions.total = result.data.total
      } else {
        this.$message.error('系统异常，请稍后再试')
      }
    },
    // 创新券分页控制
    handlePageChange(val) {
      this.pageOptions.page = val.page
      this.pageOptions.limit = val.limit
      this.getCouponList()
    },
    // 点击查看详情
    async handleViewRedemptionDetails(val) {
      this.showDialog = true
      this.$nextTick(() => {
        this.uuid = val.dfid // 记录uuid
        this.$refs.childRef.editForm(val.dfid)
      })
    },
    // 关闭弹窗
    closeDialog() {
      this.showDialog = false
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-table {
  max-height: 260px !important;
  overflow: auto !important;
}

.contentBox {
  width: 100%;
  height: 100%;

  .tableBox {
    margin-top: 25px;
  }
}

::v-deep .el-table::before {
  background-color: transparent !important;
}

.innovationVoucher {
  font-weight: bold;
  display: flex;
  align-items: center;
  font-size: 20px;
  color: #333333;
  margin-bottom: 15px;

  span {
    margin-left: 10px;
  }
}

/* 控制全选按钮样式 */
.select-popover-class .el-scrollbar__view>.el-checkbox {
  padding: 5px 20px;
}

/* 取消多选框触发事件 */
.select-popover-class .el-scrollbar__view>li .el-checkbox {
  pointer-events: none;
}

/* 隐藏多选框选中勾选样式 √ */
.select-popover-class .el-scrollbar__view>li::after {
  display: none;
}

// 企业兑付申请表单样式
.applyform {
  padding: 10px;

  .box-cards {
    margin-bottom: 10px;

    .card-title {
      display: flex;
      align-items: center;

      div {
        width: 5px;
        height: 13px;
        background: rgb(88, 155, 248);
        margin-right: 10px;
      }

      span {
        font-size: 18px;
        font-weight: bold;
      }
    }
  }
}

::v-deep .el-form {
  .el-form-item {
    display: flex;
  }

  .el-form-item__content {
    margin-left: 10px !important;
  }
}
</style>
